import { loader as featureCheckLoader } from '@plugins/client/feature-check';
import {
  KeyAndLoader,
  registerPluginTranslation,
} from '@plugins/client/translate/loaders';

export const TRANSLATION_KEY = 'id-card-common';
export const commonLoader = (lang: string) =>
  import(`../../assets/i18n/common/${lang}.json`);
const commonSource: KeyAndLoader = {
  loader: (lang) => [commonLoader(lang), featureCheckLoader(lang)],
  key: TRANSLATION_KEY,
};

export const loadCommonTranslations = registerPluginTranslation(commonSource);
